import React from "react";
import { Image, Flex } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

import { DeviceStatus } from "../../results-view/ResultsView.types";
import { useDeviceStatusDialogBoxStyles } from "../DeviceStatusDialogBox.styles";

import { DialogIconProps } from "./DialogIcon.types";

export const DialogIcon: React.FC<DialogIconProps> = ({ status }) => {
  const deviceStatusViewStyles = useDeviceStatusDialogBoxStyles();
  const { t } = useTranslation();

  // If not currently connected don't render svg
  if (!navigator.onLine) {
    return <Flex styles={deviceStatusViewStyles.dialogIcon}></Flex>;
  }

  switch (status) {
    case DeviceStatus.WORKING:
      return (
        <Image
          key="working"
          alt={t("THUMBS_UP_ALT")}
          src={"/assets/images/thumbsUp.svg"}
          styles={deviceStatusViewStyles.dialogIcon}
        />
      );
    case DeviceStatus.UNTESTED:
    case DeviceStatus.FAILED:
    case DeviceStatus.UNAVAILABLE:
    case DeviceStatus.MISSING:
      return (
        <Image
          key="failed"
          alt={t("SURPRISED_ALT")}
          src={"/assets/images/surprisedPerson.svg"}
          styles={deviceStatusViewStyles.dialogIcon}
        />
      );
    default:
      return <Flex styles={deviceStatusViewStyles.dialogIcon}></Flex>;
  }
};
